import { useBillingViewModel } from "@onetasklist/shared";
import { useApi } from "@api/useApi";
import type { PastDueBannerViewModel } from "./PastDueBanner.ViewModel.types";

const redirectToStripe = (url: string): void => {
  window.location.assign(url);
};

export const usePastDueBannerViewModel = (): PastDueBannerViewModel => {
  const api = useApi();
  const billing = useBillingViewModel({ billingApi: api.billing, redirect: redirectToStripe });

  return {
    isVisible: billing.isBillingEnabled && billing.isPastDue,
    isOpeningPortal: billing.isOpeningPortal,
    portalError: billing.portalError,
    updateCard: () => void billing.openPortal(),
  };
};
